import { CORE_API_URL } from '../../config';
import { createApiClient } from './client';

export const coreApiClient = createApiClient(CORE_API_URL);
